export class ApiResponseError extends Error {
    constructor(details) {
        super(details.message);
        this.details = details;
    }
}
